import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Projects from '../pages/admin/project/Project';
import Assignments from '../pages/admin/assigment/Assignments';
import ManHour from '../pages/admin/manhour/ManHour';
import Cost from '../pages/admin/cost/Cost';
import Employee from '../pages/admin/employee/Employee';
import ReportManagement from '../pages/admin/reportManagement/ReportManagement';
import Rate from '../pages/admin/rate/Rate';
import Workingtime from '../pages/common/workingtime/Workingtime';
import CostAccounting from '../pages/admin/costAccounting/CostAccounting';
import CostAccountingDairen from '../pages/admin/costAccountingDairen/CostAccountingDairen';
import UnitPrice from '../pages/admin/unitprice/UnitPrice';
import AdminSidebarLayout from '../components/sidebar/AdminSidebarLayout';

// 管理者画面のルートを定義する
const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminSidebarLayout />}>
        <Route path="/projects" element={<Projects />} />
        <Route path="/assignment/:projectId" element={<Assignments />} />
        <Route path="/manhours" element={<ManHour />} />
        <Route path="/projects/:projectId/costs" element={<Cost />} />
        <Route path="rates" element={<Rate />} />
        <Route path="projects" element={<Projects />} />
        <Route path="/employees" element={<Employee />} />
        <Route path="/reports" element={<ReportManagement />} />
        <Route path="/rates" element={<Rate />} />
        <Route path="/costaccounting/tokyo" element={<CostAccounting />} />
        <Route
          path="/costaccounting/dairen"
          element={<CostAccountingDairen />}
        />
        <Route path="/workingtime" element={<Workingtime />} />
        <Route path="/unitprice" element={<UnitPrice />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;
